import { Component } from '@angular/core';
import { NavController } from 'ionic-angular';
import { PromotionService } from '../../services/promotion.service';
import { LoaddingService } from '../../providers/loadding.service';
import { PromotionDetail } from './promotiondetail';



@Component({
  selector: 'page-promotion',
  templateUrl: 'promotion.html',
  providers: [PromotionService]
})
export class PromotionPage {

  articles = [];
  constructor(
    private promotionService: PromotionService,
    private loadding: LoaddingService,
    private navCtrl: NavController
  ) { }

  ionViewDidLoad() {
    this.getAnnounce();
  }

  //获取公告列表
  //TQQ 2017-01-19
  getAnnounce() {
    let load = this.loadding.showLoding("加载中..");
    this.promotionService.getAnnounces().then(s => {
      // 匹配公告表情包
      if (s) {
        s.forEach(data => {
          data.Summary = data.Summary.replace(/\/Images\/emojis/ig,'http:\/\/appapi.xb5.mobi\/Images\/emojis');
          data.Summary = data.Summary.replace(/<img/ig,"<img style='width:20%;height:20%;'");
        });
        this.articles = s;
      }
      this.loadding.closeLoading(load);
    });
  }


  //查看公告详情
  //TQQ 2017-01-19
  goDetail(detail) {
    this.navCtrl.push(PromotionDetail, { summary: detail });
  }

}



// WEBPACK FOOTER //
// ./src/pages/promotion/promotion.ts